import React from "react";
import Section4_posts from "./blog";
import axios from "axios";
import { useEffect, useState } from "react";
import { useBlogHeader } from "../../../hooks/apis/headers";

function Section4_index() {
  // const [blogTitle, setblogTitle] = useState('');
  const { data, isLoading } = useBlogHeader();

  // if (isLoading) return <div className="active loading">
  //     <img src="/images/loading.svg" className="img-fluid" />
  // </div>;
  // if (error) return <p>Error</p>;

  // console.log(data);

  // useEffect(() => {
  //     axios.get('https://panel.baghban.restaurant/api/header/blog')
  //         .then(response => {
  //             setblogTitle(response.data.title);
  //         })
  //         .catch(error => {
  //             console.error(error);
  //         });
  // }, []);

  return (
    <div id="section4">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* Title section */}
            <div className="title-section">
              <h2>{data?.title}</h2>
              {/* <p className="subtitle-section">
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد
                            </p> */}
            </div>
            {/* Post list */}
            <div className="blog-posts">
              <Section4_posts />
              <div className="post-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section4_index;
